/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { CreateCourseSectionOptions, CreateCourseSectionResponses } from '../../models/CreateCourseSection'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Create Course Section
 * {@link /admin/course/:course_id/sections/create}
 */
export function createCourseSection<ThrowOnError extends boolean = true>(options: Options<CreateCourseSectionOptions, ThrowOnError>): Promise<UnwrappedResult<CreateCourseSectionResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/course/{course_id}/sections/create', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<CreateCourseSectionResponses, ThrowOnError>>
}
